// extracted by mini-css-extract-plugin
export default {"geocoder":"Map--geocoder--Oxjyx"};